module.exports = __webpack_public_path__ + "static/partner2-2cedbe6f7fbdde4686cb30b5f5b95c32.png";